/**
 * @author xuna
 */
import Oidc from 'oidc-client'
import { environment } from '@/environments/environment';
import storage from '@/common/storage';
import { superadmin } from '@/common/jdyrole';
import { setTimeout } from 'timers';
const mgr = new Oidc.UserManager(environment.identityConfig);

Oidc.Log.logger = window.console;
Oidc.Log.level = Oidc.Log.INFO;

mgr.events.addUserLoaded(function (user) {
  console.log('New User Loaded：', arguments);
  console.log('Acess_token: ', user, user.access_token)
});

mgr.events.addAccessTokenExpiring(function () {
  console.log('AccessToken Expiring：', arguments);
});

mgr.events.addAccessTokenExpired(function () {
  console.log('AccessToken Expired：', arguments);
  mgr.signoutRedirect().then(function (resp) {
   console.log('signed out', resp);
  }).catch(function (err) {
   console.log(err)
  })
});

mgr.events.addSilentRenewError(function () {
  console.log('Silent Renew Error：', arguments);
});

mgr.events.addUserSignedOut(function () {
  console.log('UserSignedOut：', arguments);
  mgr.removeUser().then(res => {
   mgr.signoutRedirect().then(function (resp) {
     console.log('signed out', resp);
   }).catch(function (err) {
     console.log(err)
   })
  });
});

let allowNav = [];
allowNav.push({
  name: 'company',
  path: "/company",
  title: "公司信息",
  icons: '',
  sub: [
    { name: "message", path: "/company/message-list", title: '信息管理' },
  ]
});

allowNav.push({
  name: 'template',
  path: "/template",
  title: "详情模板",
  icons: '',
  sub: [
    { name: "articleList", path: "/template/article-list", title: '文章模板' },
    { name: "productlist", path: "/template/product-list", title: '产品模板' },
    { name: "locallist", path: "/template/local-list", title: '局部模板' },
    { name: "classification", path: "/template/classification", title: '模板分类' }
  ]
});

allowNav.push({
  name: 'theme',
  path: "/theme",
  title: "主题色系",
  icons: '',
  sub: [
    { name: "themeList", path: "/theme/theme-list", title: '主题管理' },
  ]
});

let userNav = null;

export default class IdentityService {
   constructor(axios) {
     this.returnUrlStorageKey = 'vuex_oidc_authroute';
     this.userKey = `oidc.user:${environment.identityConfig.authority}:${environment.identityConfig.client_id}`;
     this.storage = storage;
     this.axios = axios;
     this.isGetFromIdentity = false;
   }
  /**
   * 获取当前用户
   * */
  getUser() {
    let storageUser = this.storage.getItem(this.userKey);
    if (storageUser) {
      return JSON.parse(storageUser);
    }
    return null;
  }
  /**
   * 获取用户对象
   * */
  getUserProfile() {
    return this.getUser().profile;
  }
  /**
   * @method
   * 
   * */
  isAuthenticated() {
    let user = this.getUser();
    if (user == null)
      return false;

    if (!this.isGetFromIdentity) {
      this.isGetFromIdentity = true;
      let that = this;
      mgr.getUser().then(function (mgruser) {
        if (!mgruser || mgruser.expired) {
          console.log("getUser Expired");
          that.signOut();
        }
      }).catch(err => {
        console.log(err);
      });
    }
    let expired = user.expires_at <= parseInt((new Date()).valueOf() / 1000);
    console.log("expired:", expired)
    return !expired;
  }
  /**
   * 存储登录跳转地址
   */
  storageReturnUrl(url) {
    let returnUrl = url || (document.location.pathname + document.location.search);
    this.storage.setItem(this.returnUrlStorageKey, returnUrl);
  }

  /**
   * 跳转登录页面
   */
  signIn() {
    this.storageReturnUrl();
    window.location.href = '/login.html?returnUrl=' + returnUrl;
  }
  /**
   * 跳转到验证中心登录页
   */
  signInRedirect() {
    mgr.signinRedirect().catch(function (err) { console.log(err) });
  }
  /**
   * 登出
   */
   signOut() {
     this.storage.removeItem(this.userKey);
     this.isGetFromIdentity = false;
     mgr.signoutRedirect()
       .then(function (resp) {
         //window.location.href = "http://localhost:5800/login.html";
       }).catch(function (err) {
         console.log(err);
       });
   }
  /**
   * 权限验证
   * @method 
   * @param {Route} route 路由对象
   * 例：
   * {
   *    route:Route
   * }
   * @returns {boolean} 是否允许
   * @desc 根据路由验证登录权限
   */
  //checkAccess(route) {
  //  let hasAccess = true;
  //  // 验证登录
  //  if (route.matched.some(record => record.meta.requiresAuth)) {
  //    if (!this.isAuthenticated()) {
  //      this.signIn();
  //      hasAccess = false;
  //    }
  //  }
  //  // 验证角色
  //  if (hasAccess && route.meta.requiresRole) {
  //    if (!this.checkRole(route.meta.roleRequire)) {
  //      console.log("checkrole", false);
  //      hasAccess = false;
  //    }
  //  }
  //  return hasAccess;
  //}

  /**
   * 验证角色
   * @param {any} role
   */
  checkRole(role) {
    let user = this.getUser();
    if (user && user.profile && user.profile.role) {
      let userRole = user.profile.role;
      if (typeof (userRole) == "string") {
        if (userRole == superadmin) {
          return true;
        }
        if (typeof (role) == "string") {
          return userRole == role;
        } else {
          if (typeof (role) === "object") {
            for (let i = 0; i < role.length; i++) {
              if (userRole == role[i]) {
                return true;
              }
            }
          }
        }
      } else {
        if (typeof (role) == "string") {
          for (let i = 0; i < userRole.length; i++) {
            if (userRole[i] == superadmin) {
              return true;
            }
            if (userRole[i] == role) {
              return true;
            }
          }
        } else {
          for (let i = 0; i < userRole.length; i++) {
            if (userRole[i] == superadmin) {
              return true;
            }
            if (typeof (role) === "object") {
              for (let cki = 0; cki < role.length; cki++) {
                if (userRole[i] == role[cki]) {
                  return true;
                }
              }
            }
          }
        }
      }
    }
    return false;
  }
  /**
   *  登录回调方法
   * */
  signInCallback() {
    let that = this;
    return new Promise((resolve, reject) => {
      mgr.signinRedirectCallback()
        .then(function (user) {
          that.isGetFromIdentity = true;
          resolve(that.storage.getItem(that.returnUrlStorageKey) || '/');
        })
        .catch(function (err) {
          reject(err);
        });
    });
  }
  /**
   * 刷新回调
   * */
   signinSilentCallback() {
     mgr.signinSilentCallback();
   }
  /**
   * 获取导航菜单
   * */
   getNav() {
      return allowNav;
    }
}



// WEBPACK FOOTER //
// ./src/service/identity.js